import groupBy from 'lodash-es/groupBy';
import isEmpty from 'lodash-es/isEmpty';

import { goodOptionValidation } from '@ecp/common/src/utils/good/goodUtil';
import { MAX_ORDER_COUNT, BULKP_MAX_ORDER_COUNT, DIALOG_MESSAGE, OD_ORDER_MAX_COUNT_STANDARD } from '@ecp/common/src/const/good';

const useGoodOptionValidator = (showAlertDialog) => {
  const optionCountValidator = ({
    option, 
    newCount, 
    showBtnBulkp = false, 
    availableResult,
    selectedOptionList,
    ordPossibleMaxQtyStandardCode,
    ordPossibleMaxQty,
    ordPossibleMinQty,
    ordPossibleMaxAmount,
    ordPossibleMaxFormattedAmount,
    ordPossibleMinAmount,
    ordPossibleMinFormattedAmount,
    bulkpOrdPossibleMinQty,
    priceFormat,
  }) => {
    const additionalItemStockManagement = option?.additionalItem && option?.additionalItemStockManagement;
    const itemStockManagement = !option?.additionalItem && option?.stockManagement;
    const stockManagement = additionalItemStockManagement || itemStockManagement;
    const maxOrderCount = showBtnBulkp ? BULKP_MAX_ORDER_COUNT : MAX_ORDER_COUNT;

    // 주문가능 단위 체크
    let { message = '', rollback = true, reAlert = true } = goodOptionValidation({
      checkOrderAvailableResult: availableResult,
      selectedOptionList,
      isBulkpOrder: false,
      ordPossibleMaxQtyStandardCode,
      ordPossibleMaxQty,
      ordPossibleMinQty,
      ordPossibleMaxAmount,
      ordPossibleMaxFormattedAmount,
      ordPossibleMinAmount,
      ordPossibleMinFormattedAmount,
      bulkpOrdPossibleMinQty,
      priceFormat,
      showBtnBulkp,
    });

    if (stockManagement && newCount > option?.salePossibleQuantity) {
      message = '주문할 수 있는 재고 수량을 초과했습니다.';
    }

    if (maxOrderCount < newCount) {
      message = `최대 주문 가능 수량은 ${maxOrderCount} 개 입니다.`;
    }

    return {message, rollback, reAlert};
  };

  const optionCtaButtonValidator = (goodOptionList, isRegularDelivery, regularDelivery, selectedRegularDelivery) => {
    if (isRegularDelivery && isEmpty(selectedRegularDelivery.period.code)) {
      showAlertDialog(DIALOG_MESSAGE.REGULAR_DELIVERY_PERIOD);
      return false;
    }

    if (isRegularDelivery && !selectedRegularDelivery.total) {
      showAlertDialog(DIALOG_MESSAGE.REGULAR_DELIVERY_TOTAL);
      return false;
    }

    if (isRegularDelivery && regularDelivery.timeList.length > 0 && !selectedRegularDelivery.time) {
      showAlertDialog(DIALOG_MESSAGE.REGULAR_DELIVERY_TIME);
      return false;
    }

    if (isRegularDelivery && !selectedRegularDelivery.startDateTime) {
      showAlertDialog(DIALOG_MESSAGE.REGULAR_DELIVERY_START_TIME);
      return false;
    }

    if (goodOptionList?.length <= 0) {
      showAlertDialog(DIALOG_MESSAGE.OPTION_REQUIRED);
      return false;
    }

    const goodNumberToGoodOptionList = groupBy(goodOptionList, (option) => option.goodNumber);
    const onlyAdditionalItem = Object.values(goodNumberToGoodOptionList).some((optionList) => {
      const optionWithoutAdditional = optionList.filter((option) => !option.additionalItem);
      return optionWithoutAdditional.length <= 0;
    });
    if (onlyAdditionalItem) {
      showAlertDialog(DIALOG_MESSAGE.NOT_ONLY_ADDITIONAL);
      return false;
    }

    return true;
  };

  const optionDropdownValidator = (option, good, goodOptionList) => {
    const alreadyAdded = goodOptionList.some(
      ({ itemNumber, goodNumber }) => option.goodNumber === goodNumber && option.itemNumber === itemNumber
    );
    if (alreadyAdded) {
      showAlertDialog('이미 추가된 옵션입니다. 수량 조절은 아래 선택사항에서 해주십시오.');
      return false;
    }

    return true;
  };

  return { optionCountValidator, optionCtaButtonValidator, optionDropdownValidator };
};

export default useGoodOptionValidator;
